import React, { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Radios, Button, Details } from 'govuk-react-jsx';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import {
  setPmcLandlordType,
  getPmcLandlordType,
} from '../../features/pmc/pmcJourneySlice';
import useTitle from '../../hooks/useTitle';
import { updateAccount } from '../../firebase';

const LandlordType = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const pmcLandlordTypeRedux = useSelector(getPmcLandlordType);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  useTitle(
    'pmcReg.LandlordType.s19',
    'What type of landlord is your client? - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );

  const errorMsg = {
    children: copyProvider.getCopy(
      'pmcReg.LandlordType.s18',
      'Select an option'
    ),
  };

  const detailsSummaryChildren = copyProvider.getCopy(
    'pmcReg.LandlordType.s5',
    'What is a public authority or social housing provider?'
  );

  const handleSelection = (event) => {
    dispatch(setPmcLandlordType(event.target.value));
  };

  const handleBtnClick = () => {
    if (!pmcLandlordTypeRedux) {
      setError(errorMsg);
    } else {
      updateAccount({
        landlordType: pmcLandlordTypeRedux,
      })
        .then(() => {
          setError(null);
          if (pmcLandlordTypeRedux === 'Private landlord') {
            history.push('/pmcClientReg/linked-enterprise');
          } else {
            history.push('/pmcReg/company-registration-number');
          }
        })
        .catch(() => {
          setError(errorMsg);
        });
    }
  };

  const pageModel = (
    <>
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy(
          'pmcReg.LandlordType.s1',
          'What type of landlord is your client?'
        )}
      </h1>

      <Radios
        onClick={(event) => handleSelection(event)}
        value={pmcLandlordTypeRedux}
        errorMessage={error}
        idPrefix="landlordTypepmcReg"
        items={[
          {
            children: copyProvider.getCopy(
              'pmcReg.LandlordType.s2',
              'Private landlord'
            ),
            value: 'Private landlord',
          },

          {
            children: copyProvider.getCopy(
              'pmcReg.LandlordType.s3',
              'Public authority'
            ),
            value: 'Public authority',
          },
          {
            children: copyProvider.getCopy(
              'pmcReg.LandlordType.s4',
              'Property factor or a social housing provider'
            ),
            value: 'Property factor or a social housing provider',
          },
        ]}
      />

      <Details summaryChildren={detailsSummaryChildren}>
        <p>
          <span>{copyProvider.getCopy('pmcReg.LandlordType.s6')}</span>
          <strong>{copyProvider.getCopy('pmcReg.LandlordType.s7')}</strong>
          <span>{copyProvider.getCopy('pmcReg.LandlordType.s8')}</span>
        </p>
        <p>{copyProvider.getCopy('pmcReg.LandlordType.s9')}</p>
        <p>
          {copyProvider.getCopy('pmcReg.LandlordType.s10')}
          <span>
            <Link
              to={{}}
              onClick={() =>
                window.open(
                  'https://www.ons.gov.uk/economy/nationalaccounts/uksectoraccounts/datasets/publicsectorclassificationguide',
                  '_blank'
                )
              }
              className="govuk-link"
            >
              {copyProvider.getCopy('pmcReg.LandlordType.s11')}
            </Link>
          </span>
        </p>
        <p>
          <span>{copyProvider.getCopy('pmcReg.LandlordType.s6')}</span>
          <strong>{copyProvider.getCopy('pmcReg.LandlordType.s13')}</strong>
          <span>{copyProvider.getCopy('pmcReg.LandlordType.s14')}</span>
        </p>
        <p>
          <strong>{copyProvider.getCopy('pmcReg.LandlordType.s15')}</strong>
          <span>{copyProvider.getCopy('pmcReg.LandlordType.s16')}</span>
        </p>
      </Details>

      <Button className="govuk-button" onClick={handleBtnClick}>
        {copyProvider.getCopy('pmcReg.LandlordType.s17', 'Save and continue')}
      </Button>
    </>
  );

  return pageModel;
};

export default LandlordType;
